import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export type DealerPlanCode = "start" | "standard" | "large";

export interface DealerPlanOption {
  code: DealerPlanCode;
  name: string;
  price: number;
  listingsLabel: string;
  bullets: string[];
  recommended?: boolean;
}

export const DEALER_PLANS: DealerPlanOption[] = [
  {
    code: "start",
    name: "Start",
    price: 29.99,
    listingsLabel: "până la 5 anunțuri active",
    bullets: [
      "5 anunțuri active",
      "Dashboard complet",
      "Notificări lead-uri",
      "Anulare oricând",
    ],
  },
  {
    code: "standard",
    name: "Standard",
    price: 50,
    listingsLabel: "până la 60 anunțuri active",
    recommended: true,
    bullets: [
      "60 anunțuri active",
      "1 slot featured pe homepage",
      "Prioritate în listare",
      "Rapoarte performanță",
    ],
  },
  {
    code: "large",
    name: "Mare",
    price: 120,
    listingsLabel: "anunțuri nelimitate",
    bullets: [
      "Anunțuri nelimitate",
      "3 sloturi featured",
      "Poziționare de top",
      "Suport prioritar",
    ],
  },
];

interface Props {
  value: DealerPlanCode | null;
  onChange: (code: DealerPlanCode) => void;
}

export function DealerPlanSelector({ value, onChange }: Props) {
  return (
    <div className="space-y-3">
      <p className="text-sm font-semibold text-foreground">Alege pachetul</p>
      <div className="grid gap-3">
        {DEALER_PLANS.map((plan) => {
          const active = value === plan.code;
          return (
            <button
              key={plan.code}
              type="button"
              onClick={() => onChange(plan.code)}
              className={cn(
                "relative w-full text-left rounded-lg border-2 p-4 transition-all",
                active
                  ? "border-primary bg-primary/5 ring-2 ring-primary/20"
                  : "border-border hover:border-primary/50 bg-background"
              )}
            >
              {plan.recommended && (
                <span className="absolute -top-2 right-3 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide bg-primary text-primary-foreground rounded-sm">
                  Recomandat
                </span>
              )}
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-bold text-base text-foreground">{plan.name}</p>
                  <p className="text-xs text-muted-foreground">{plan.listingsLabel}</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="font-bold text-lg text-foreground leading-none">
                    {plan.price.toString().replace(".", ",")}€
                  </p>
                  <p className="text-[10px] text-muted-foreground">/lună</p>
                </div>
              </div>
              <ul className="mt-3 space-y-1">
                {plan.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-1.5 text-xs text-muted-foreground">
                    <Check className={cn("h-3.5 w-3.5 mt-0.5 shrink-0", active ? "text-primary" : "text-muted-foreground/60")} />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-center text-muted-foreground">
        Plata se face la înregistrare, prin Stripe. Anulare oricând, fără penalizare.
      </p>
    </div>
  );
}
